
import { useTranslation } from 'react-i18next';

interface WeChatModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function WeChatModal({ isOpen, onClose }: WeChatModalProps) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl p-8 max-w-sm w-full mx-4 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer"
        >
          <i className="ri-close-line text-xl"></i>
        </button>
        
        <div className="text-center">
          <h3 className="text-xl font-bold text-gray-900 mb-6">
            {t('contact_wechat_qr')}
          </h3>
          
          <div className="mb-6">
            <img 
              src="/resources/0e46a1b8dadcccc635e6d9e17aeb8718.jfif"
              alt={t('contact_wechat_qr')}
              className="w-48 h-48 mx-auto border border-gray-200 rounded-lg object-cover"
            />
          </div>
          
          <div className="text-center">
            <p className="text-sm text-gray-600 mb-2">
              {t('contact_wechat_id')}
            </p>
            <p className="text-lg font-semibold text-gray-900 mb-4">
              ljy520155
            </p>
            <p className="text-sm text-gray-500">
              {t('contact_scan_add')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
